//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { dragMoveAction1 } from '@/common/utils/drag.js'
  import fetchImgMX from '@/common/mixin/getfetchImg.js'
  import GDialog from '@/common/components/g-dialog/'
  export default {
	components: { GDialog },
    mixins: [fetchImgMX],
    data() {
      return {
        show: false,
        homePendant: null, //首页挂件
        homeDialogList: null // 首页弹框
      }
    },
    created() {
      // this._getfetchImg('h5HomePendant') // 首页挂件
      if(this.$store.state.homeFloatTopShow) this._getfetchImg('ekgameh5HomeDialog') // 获取首页弹窗
    },
    methods: {
      implementationFetched([data, res], imgCode) {
        if (imgCode === 'h5HomePendant') {
          this.homePendant = data
          this.$nextTick(() => {
            dragMoveAction1('H5Drag')
          })
        }
        if (imgCode === 'ekgameh5HomeDialog') {
          this.homeDialogList = data
          this.show = true
          this.$store.commit('setHomeFloatTop', false)
        }
      }
    },
    destroyed() {
      this.show = false
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/components/home-dialog.vue